module.exports = __webpack_public_path__ + "img/bitcoin-btc-gold.da29dfb6.svg";